import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["ConjunctiveFacet", "DisjunctiveFacet", "facetType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component } from 'react';
import { CONJUNCTIVE_FACET_TYPE, DISJUNCTIVE_FACET_TYPE } from '../../../../../common/records/FacetType';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FacetContent extends Component {
  render() {
    const _this$props = this.props,
      {
        ConjunctiveFacet,
        DisjunctiveFacet,
        facetType
      } = _this$props,
      otherProps = _objectWithoutProperties(_this$props, _excluded);
    switch (facetType) {
      case DISJUNCTIVE_FACET_TYPE:
        return /*#__PURE__*/_jsx(DisjunctiveFacet, _objectSpread({}, otherProps));
      case CONJUNCTIVE_FACET_TYPE:
        return /*#__PURE__*/_jsx(ConjunctiveFacet, _objectSpread({}, otherProps));
      default:
        console.error("Invalid facet type '".concat(facetType, "'."));
    }
  }
}